var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMonetaryVerifications = function SvgMonetaryVerifications(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6684_310)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6684_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6447 54.4767C47.2192 54.1776 47.9029 54.1753 48.4794 54.4703L75.3444 68.2196C76.7962 68.9626 76.7962 71.0374 75.3444 71.7804L48.4794 85.5297C47.9029 85.8247 47.2192 85.8224 46.6447 85.5233L20.2312 71.774C18.7958 71.0269 18.7958 68.9731 20.2312 68.226L46.6447 54.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6684_310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 12,
    width: 64,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 13.1547C47.2376 12.4402 48.7624 12.4402 50 13.1547L77.177 28.8453C78.4146 29.5598 79.177 30.8803 79.177 32.3094V63.6906C79.177 65.1197 78.4146 66.4402 77.177 67.1547L50.0001 82.8453C48.7624 83.5598 47.2376 83.5598 46 82.8453L18.8239 67.1547C17.5864 66.4402 16.824 65.1197 16.824 63.6907L16.8232 32.3095C16.8231 30.8804 17.5855 29.5598 18.8232 28.8453L46 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6684_310)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.0372 12)",
    fill: "url(#paint0_linear_6684_310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.4702 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.0372 48)",
    fill: "url(#paint1_linear_6684_310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.0952 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 16.8611 30)",
    fill: "url(#paint2_linear_6684_310)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 16.9191 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4999 14.0205C47.428 13.4847 48.5717 13.4847 49.4999 14.0205L76.6766 29.7109C77.6048 30.2468 78.1766 31.2378 78.1766 32.3096V63.6904C78.1766 64.7622 77.6048 65.7532 76.6766 66.2891L49.4999 81.9795C48.5717 82.5153 47.428 82.5154 46.4999 81.9795L19.3241 66.2891C18.3959 65.7532 17.8241 64.7622 17.8241 63.6904L17.8231 32.3096C17.8231 31.2377 18.3949 30.2468 19.3231 29.7109L46.4999 14.0205Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2138 69.5233C59.1351 69.8173 59.1493 70.0818 59.2532 70.2589C59.3571 70.4361 59.5423 70.5117 59.7684 70.4693C60.3983 70.3429 61.0466 70.1422 61.7052 69.8695L61.8325 69.796C61.9519 69.7362 62.0718 69.6503 62.1853 69.5431C62.2989 69.436 62.4038 69.3096 62.4941 69.1714C62.5845 69.0331 62.6585 68.8856 62.7119 68.7373C62.7653 68.589 62.7971 68.4428 62.8055 68.3071C62.8138 68.1713 62.7986 68.0487 62.7606 67.9461C62.7226 67.8436 62.6627 67.7632 62.5842 67.7094C62.5056 67.6557 62.4101 67.6298 62.303 67.633C62.1958 67.6363 62.0792 67.6688 61.9598 67.7285C61.4185 67.9525 60.8857 68.1166 60.3686 68.2185C60.2546 68.2424 60.1341 68.2951 60.0141 68.3738C59.8942 68.4524 59.7771 68.5554 59.6697 68.6768C59.5623 68.7981 59.4667 68.9354 59.3884 69.0807C59.3102 69.2261 59.2508 69.3765 59.2138 69.5233Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6313 70.3663C56.7938 70.4154 56.996 70.376 57.2042 70.2549C57.3982 70.1479 57.5886 69.9749 57.7475 69.7611C57.9065 69.5473 58.0257 69.3039 58.0877 69.0665C58.1496 68.8291 58.1512 68.6101 58.092 68.4416C58.0328 68.2732 57.9161 68.164 57.7589 68.1301C57.2439 67.9708 56.7773 67.7219 56.3677 67.3879C56.2203 67.2646 56.0036 67.2538 55.765 67.3579C55.5264 67.462 55.2853 67.6726 55.0947 67.9435C54.9992 68.0787 54.9192 68.2249 54.8592 68.3737C54.7993 68.5226 54.7606 68.671 54.7454 68.8106C54.7301 68.9501 54.7387 69.0779 54.7706 69.1865C54.8024 69.2952 54.8569 69.3826 54.931 69.4437C55.4323 69.8555 56.0026 70.1649 56.6313 70.3663Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1217 67.1393C54.2149 67.104 54.3104 67.0489 54.4036 66.9766C54.5264 66.871 54.6411 66.7422 54.7406 66.5986C54.84 66.4549 54.9219 66.2995 54.981 66.1424C55.04 65.9853 55.075 65.83 55.0836 65.6863C55.0923 65.5427 55.0743 65.4139 55.031 65.3083C54.8595 64.8363 54.7377 64.3191 54.6673 63.7635C54.6485 63.6446 54.6065 63.5444 54.5437 63.4688C54.4809 63.3931 54.3986 63.3434 54.3014 63.3226C54.2042 63.3018 54.0941 63.3103 53.9775 63.3476C53.8608 63.3848 53.7399 63.4502 53.6216 63.5398C53.5027 63.6245 53.3878 63.7324 53.2836 63.8575C53.1793 63.9825 53.0878 64.1221 53.0143 64.2683C52.9408 64.4146 52.8867 64.5645 52.8552 64.7094C52.8236 64.8544 52.8153 64.9916 52.8305 65.1131C52.9122 65.7878 53.0584 66.4147 53.267 66.9847C53.332 67.138 53.4488 67.235 53.6016 67.2626C53.7544 67.2903 53.9359 67.2472 54.1217 67.1393Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4058 47.5829C64.9509 47.3475 65.4872 47.1782 66.0062 47.0777C66.1058 47.0346 66.2066 46.9764 66.3062 46.9044C66.5231 46.7811 66.7334 46.5765 66.8992 46.3276C67.0651 46.0786 67.1755 45.8017 67.2106 45.5468C67.2458 45.2919 67.2032 45.0757 67.0908 44.9374C66.9783 44.799 66.8032 44.7476 66.5972 44.7923C65.9668 44.9258 65.3185 45.1332 64.6604 45.412C64.4217 45.5129 64.1793 45.7213 63.9866 45.9915C63.7939 46.2616 63.6667 46.5714 63.6329 46.8527C63.6096 46.9995 63.6113 47.1356 63.6379 47.2528C63.6646 47.37 63.7157 47.4657 63.7881 47.534C63.8604 47.6024 63.9525 47.642 64.0588 47.6504C64.165 47.6588 64.2831 47.6358 64.4058 47.5829Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0616 47.9266C70.1463 47.9984 70.2551 48.0333 70.3796 48.0288C70.5041 48.0244 70.641 47.9805 70.7799 47.9007C70.9852 47.7703 71.1807 47.5695 71.3346 47.3312C71.5247 47.0599 71.6487 46.7507 71.6793 46.4714C71.71 46.192 71.6449 45.9654 71.4982 45.841C71.0047 45.4142 70.4337 45.101 69.7979 44.9084C69.7029 44.8821 69.5944 44.8849 69.4783 44.9167C69.3623 44.9485 69.2411 45.0088 69.1216 45.0939C68.8803 45.266 68.6607 45.5292 68.5112 45.8258C68.3617 46.1223 68.2945 46.4278 68.3243 46.6752C68.3542 46.9225 68.4786 47.0914 68.6704 47.1446C69.1896 47.311 69.6566 47.5735 70.0616 47.9266Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4528 50.0644C71.6186 50.543 71.7314 51.0691 71.7892 51.6349C71.8139 51.8656 71.9205 52.0303 72.0884 52.0972C72.2564 52.1641 72.4737 52.1285 72.6985 51.9972L72.7985 51.9395C73.0369 51.7718 73.2547 51.5138 73.4046 51.2219C73.5545 50.9299 73.6242 50.6276 73.5987 50.3808C73.5367 49.6899 73.4088 49.0457 73.2168 48.4577C73.1401 48.2569 72.9794 48.147 72.7688 48.1512C72.5581 48.1553 72.3141 48.2733 72.0883 48.4802C71.8625 48.687 71.6728 48.9664 71.5592 49.2592C71.4457 49.5519 71.4173 49.8351 71.48 50.0487L71.4528 50.0644Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5768 56.2804L59.0501 55.9292C59.137 55.9201 59.2109 55.9457 59.2627 56.0027C59.3144 56.0597 59.3417 56.1456 59.3411 56.2497C59.3423 56.3166 59.3312 56.3902 59.3084 56.4662C59.2857 56.5422 59.2517 56.619 59.2085 56.6922C59.1653 56.7654 59.1138 56.8335 59.0569 56.8925C59.0001 56.9516 58.939 57.0003 58.8773 57.0359L56.4405 58.4428C56.2912 58.529 56.1434 58.6466 56.0055 58.7888C55.8676 58.931 55.7423 59.0952 55.6367 59.2718C55.5312 59.4485 55.4475 59.6342 55.3904 59.8184C55.3332 60.0026 55.3038 60.1816 55.3038 60.3453C55.3038 60.5089 55.3332 60.654 55.3904 60.7722C55.4475 60.8905 55.5312 60.9795 55.6367 61.0343C55.7423 61.0891 55.8676 61.1085 56.0055 61.0915C56.1434 61.0746 56.2912 61.0215 56.4405 60.9353L56.8496 60.699C56.9099 60.6642 56.9677 60.6571 57.0104 60.6792C57.053 60.7014 57.077 60.7509 57.077 60.8171L57.077 60.9566C57.077 61.2872 57.1967 61.535 57.4099 61.6457C57.623 61.7563 57.9121 61.7207 58.2136 61.5466C58.515 61.3726 58.8041 61.0744 59.0173 60.7176C59.2304 60.3608 59.3502 59.9747 59.3502 59.6442L59.3502 59.4049C59.3489 59.3725 59.3539 59.3366 59.3649 59.2994C59.3758 59.2622 59.3925 59.2245 59.4139 59.1887C59.4353 59.153 59.4608 59.1199 59.489 59.0916C59.5172 59.0633 59.5473 59.0404 59.5775 59.0244C60.1483 58.5512 60.6618 57.9135 61.042 57.2055C61.4222 56.4976 61.649 55.757 61.6888 55.0934C61.7285 54.4298 61.5792 53.8783 61.2628 53.5206C60.9465 53.1628 60.4799 53.0178 59.9321 53.1069L57.4225 53.4691C57.3341 53.4844 57.2582 53.4626 57.206 53.4068C57.1537 53.351 57.1276 53.2641 57.1315 53.1586C57.1315 53.0237 57.1804 52.8662 57.2673 52.7206C57.3543 52.575 57.4723 52.4534 57.5952 52.3824L60.0321 50.9754C60.3336 50.8014 60.6227 50.5032 60.8358 50.1464C61.049 49.7896 61.1687 49.4035 61.1687 49.073C61.1687 48.7424 61.049 48.4946 60.8358 48.3839C60.6227 48.2733 60.3336 48.3089 60.0321 48.4829L59.5775 48.7454C59.5172 48.7802 59.4594 48.7874 59.4168 48.7652C59.3741 48.7431 59.3502 48.6935 59.3502 48.6274L59.3502 48.4779C59.3502 48.1474 59.2304 47.8995 59.0173 47.7889C58.8041 47.6782 58.515 47.7138 58.2136 47.8879C57.9121 48.0619 57.623 48.3601 57.4099 48.7169C57.1967 49.0737 57.077 49.4598 57.077 49.7903L57.077 50.0396C57.0781 50.0946 57.0614 50.1586 57.0299 50.2205C56.9983 50.2824 56.9539 50.3383 56.9042 50.3786C56.3347 50.8549 55.8236 51.4943 55.4463 52.2025C55.069 52.9107 54.8455 53.6502 54.8088 54.3117C54.7721 54.9732 54.9242 55.5216 55.2426 55.8761C55.5609 56.2306 56.0287 56.3723 56.5768 56.2804Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6067 65.855C69.5958 65.284 70.5627 64.4041 71.3851 63.3268C72.2075 62.2494 72.8485 61.0229 73.2271 59.8024C73.6056 58.5819 73.7046 57.4222 73.5117 56.4699C73.3187 55.5177 72.8424 54.8156 72.143 54.4525C71.4436 54.0895 70.5524 54.0817 69.5823 54.4302C68.6122 54.7787 67.6067 55.4679 66.6928 56.4105C65.779 57.3531 64.998 58.5069 64.4484 59.7259C63.8989 60.9449 63.6056 62.1744 63.6056 63.259C63.6056 64.7133 64.1325 65.8038 65.0704 66.2907C66.0083 66.7775 67.2803 66.6208 68.6067 65.855ZM65.8788 61.7471C66.0067 61.5333 66.18 61.3545 66.3607 61.2502C66.5415 61.1459 66.7148 61.1244 66.8427 61.1906L67.8338 61.7151C67.8569 61.7255 67.884 61.7282 67.9137 61.7231C67.9434 61.7179 67.975 61.705 68.0065 61.6852C68.04 61.663 68.0726 61.6339 68.1024 61.5996C68.1321 61.5653 68.1583 61.5266 68.1793 61.4857L70.3616 57.0354C70.392 56.9024 70.4474 56.7648 70.5229 56.6342C70.5985 56.5036 70.6921 56.3838 70.7957 56.285C70.8994 56.1863 71.0101 56.1114 71.1184 56.0667C71.2267 56.0221 71.3296 56.009 71.4181 56.0286C71.5067 56.0481 71.5784 56.0998 71.6273 56.1792C71.6761 56.2585 71.7005 56.3633 71.6986 56.4845C71.6966 56.6058 71.6683 56.7399 71.616 56.8757C71.5637 57.0115 71.489 57.1448 71.3982 57.2644L69.0068 62.1346C68.901 62.3552 68.7649 62.5663 68.6079 62.7533C68.451 62.9403 68.2768 63.0988 68.0975 63.2179L68.0065 63.2704C67.6649 63.4655 67.3379 63.5037 67.0973 63.3766L65.8515 62.7798C65.7872 62.7482 65.7361 62.6956 65.7011 62.625C65.6662 62.5544 65.6482 62.4673 65.6482 62.3688C65.6482 62.2703 65.6662 62.1624 65.7011 62.0515C65.7361 61.9406 65.7872 61.8289 65.8515 61.723L65.8788 61.7471Z",
    fill: "url(#paint3_linear_6684_310)",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6684_310",
    x: 3.15466,
    y: 38.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.2 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6684_310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6684_310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6684_310",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6684_310",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6684_310",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6684_310",
    x1: 68.6067,
    y1: 54.8881,
    x2: 73.3555,
    y2: 63.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6684_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMonetaryVerifications);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "monetary_verifications.8c6aa57eea204a81b81b8161c9d205cd.svg";